import { TableCell, TableRow } from "../../../../components/ui/table";
import { SystemOfRecordBadge } from "../../../../components/SystemOfRecordBadge";
import { useAuth } from "../../../../contexts/authContext";
import { getExternalWorkStepUrl } from "../../../../lib/systemOfRecord";
import { WorkStepWithUser } from "../../../../models/audit/workStep";
import { ConfiguredStateBadge } from "../../../../components/audit/ConfiguredStateBadge";

interface WorkStepTableRowProps {
  workStep: WorkStepWithUser;
  isSelected: boolean;
  onClick: (workStep: WorkStepWithUser) => void;
  rowRef?: (node: HTMLTableRowElement | null) => void;
}

export const WorkStepTableRow = ({
  workStep,
  isSelected,
  onClick,
  rowRef,
}: WorkStepTableRowProps) => {
  const { workspace } = useAuth();
  const externalWorkStepUrl =
    workspace?.systemOfRecord && workStep.externalRef
      ? getExternalWorkStepUrl(
          workspace.systemOfRecord,
          workStep.externalRef.externalOpsAuditItemId,
        )
      : null;

  return (
    <TableRow
      ref={rowRef}
      role="button"
      className={`cursor-pointer transition-colors ${
        isSelected ? "bg-blue-50 hover:bg-blue-50" : "hover:bg-stone-50"
      }`}
      onClick={() => onClick(workStep)}
    >
      <TableCell className="font-medium border-x">
        <div className="flex items-center gap-2 overflow-hidden">
          <p className="truncate" title={workStep.name}>
            {workStep.name}
          </p>
          {workStep.externalRef && (
            <SystemOfRecordBadge
              externalRef={workStep.externalRef}
              controlUrl={externalWorkStepUrl}
              source="auditboard"
              iconOnly
            />
          )}
        </div>
      </TableCell>
      <TableCell className="text-sm text-stone-600 border-r">
        <div className="truncate">{workStep.section || "-"}</div>
      </TableCell>
      <TableCell className="text-sm text-stone-600 border-r">
        <div className="truncate">{workStep.subsection || "-"}</div>
      </TableCell>
      <TableCell className="text-sm text-stone-600 border-r">
        <div className="truncate">{workStep.preparer || "-"}</div>
      </TableCell>
      <TableCell className="text-sm text-stone-600 border-r">
        <ConfiguredStateBadge state={workStep.configuredState} />
      </TableCell>
    </TableRow>
  );
};
